import { useRef, useEffect } from "react";
import C from "classnames";

import { useSandboxOutput } from "../contexts/SandboxHooks";

import S from "./OutputPanel.module.scss";

const OutputPanel = () => {
  const { outputLines } = useSandboxOutput();
  const terminalRef = useRef(null);

  // Auto-scroll to bottom when new output arrives
  useEffect(() => {
    if (terminalRef.current) {
      terminalRef.current.scrollTop = terminalRef.current.scrollHeight;
    }
  }, [outputLines]);

  return (
    <div className={S.outputPanel}>
      {outputLines.length === 0 ? (
        <div className={S.emptyState}>
          <p>No output yet. Run the application to see terminal output here.</p>
        </div>
      ) : (
        <div className={S.terminal} ref={terminalRef}>
          {outputLines.map(line => (
            <div key={line.id} className={C("atlas-code", S.outputLine)}>
              <span className={S.timestamp}>
                {line.timestamp.toLocaleTimeString([], {
                  hour: "2-digit",
                  minute: "2-digit",
                  second: "2-digit",
                })}
              </span>
              <span className={S.text}>{line.text}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default OutputPanel;
